import Model, { belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { BeniBreakdownPeriodSegment } from 'lumen/models';

export default class BeniBreakdownPeriod extends Model {
  [Type] = 'benchmark-insight/breakdown-period' as const;

  @belongsTo('benchmark-insight/breakdown-period-segment', {
    async: false,
    inverse: null,
  })
  declare total: BeniBreakdownPeriodSegment;
}
